import { render } from "./RelationSelect.vue?vue&type=template&id=29d3da12"
import script from "./RelationSelect.vue?vue&type=script&lang=js"
export * from "./RelationSelect.vue?vue&type=script&lang=js"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__